import { FC } from 'react'
import { CircularProgress, Stack } from '@mui/material'

const LoadAnimation: FC = () => {
  return (
    <Stack justifyContent="center" alignItems="center" height="100vh">
      <CircularProgress aria-label="Loading content" />
    </Stack>
  )
}

export default LoadAnimation
